
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    customClass: {
      required: true,
      type: String,
    },
  },
});
